export default "__VITE_ASSET__CEdMUD_E__"